import {Appointment} from '../../services/rest-api.service';

export class PatientData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  balance: number;
  balanceAsOf: Date;
  role: string;
  nextAppointment: Appointment;

  constructor(init:Partial<PatientData>) {
    Object.assign(this, init);
  }

  isPatient() {return this.role === 'patient';}

  isAdmin() {return this.role === 'admin';}

  isWebHook() {return this.role === 'webhook';}
}
